/**
 * 권한·모듈 코드
 * ---------------------------------------------------------------------------
 * 이 값들은 **플랫폼이 소유한다.** 원본은 플랫폼 마이그레이션
 * 0026_neco_catalog.sql · 0030_product_catalog.sql · 0034_eco_selfmeasure.sql
 * 에 있고, 여기 있는 것은 그것을 그대로 옮긴 사본이다.
 *
 * 왜 사본을 두는가
 *   제품 코드에서 권한 키를 문자열로 흩뿌려 두면 오타가 런타임까지 살아남는다.
 *   `'eco.dailylog:wrtie'` 는 컴파일도 통과하고 인가도 통과하지 못한 채
 *   "권한이 없습니다" 만 남긴다. 상수로 묶어 두면 빌드가 먼저 잡는다.
 *
 * 플랫폼에서 권한을 추가하면 이 파일도 함께 고쳐야 한다.
 */

/** 구독(엔타이틀먼트)의 단위. 요금제에 이 모듈이 없으면 화면 자체가 막힌다. */
export const ECO_MODULES = {
  DAILY_LOG: 'eco.dailylog',
  FACILITY: 'eco.facility',
  REPORT: 'eco.report',
} as const;

export type EcoModuleCode = (typeof ECO_MODULES)[keyof typeof ECO_MODULES];

/** RBAC 의 단위. 구독이 있어도 역할에 이 권한이 없으면 막힌다. */
export const ECO_PERMISSIONS = {
  SITE_READ: 'eco.site:read',
  SITE_MANAGE: 'eco.site:manage',

  FACILITY_READ: 'eco.facility:read',
  FACILITY_MANAGE: 'eco.facility:manage',

  DAILY_LOG_READ: 'eco.dailylog:read',
  DAILY_LOG_WRITE: 'eco.dailylog:write',
  /** 작성과 분리되어 있다. 법정 일지는 작성자와 확인자가 다른 것이 정상이다. */
  DAILY_LOG_CONFIRM: 'eco.dailylog:confirm',

  REPORT_EXPORT: 'eco.report:export',

  /** 자가측정 성적서. 인쇄 서식의 "3. 자가측정사항" 을 대신한다. */
  SELF_MEASURE_READ: 'eco.selfmeasure:read',
  SELF_MEASURE_MANAGE: 'eco.selfmeasure:manage',
} as const;

export type EcoPermissionKey = (typeof ECO_PERMISSIONS)[keyof typeof ECO_PERMISSIONS];

/** 플랫폼 제품 카탈로그에 등록된 이 제품의 코드. */
export const PRODUCT_CODE = 'eco';

/** 플랫폼에 보고하는 사용량 지표. metering.metric_definition 과 같아야 한다. */
export const ECO_METRICS = {
  SITE_COUNT: 'eco.site_count',
  FACILITY_COUNT: 'eco.facility_count',
  LOG_COUNT: 'eco.log_count',
  /**
   * 기업별 DB 사용량(바이트). 파일 저장과 따로 잰다 — 원가가 다르다.
   *
   * 제품별 지표다. 수집 API 가 **보고하는 제품이 소유한 지표만** 받으므로
   * 공통 이름(db.size_bytes)으로 두면 버려진다. 제품마다 DB 가 따로 있으니
   * 제품별로 두는 것이 실제와도 맞다.
   */
  DB_BYTES: 'eco.db_bytes',
} as const;
